import React, { useState } from 'react';

const PageLearning = () => {
    const email = "hello@onewriter.app";
    const phone = "2125805707";
    const [emailCopied, setEmailCopied] = useState(false);

    const handleEmailClick = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(email).then(() => {
            setEmailCopied(true);
            setTimeout(() => setEmailCopied(false), 4000);
        });
    };

    return (
        <div style={{
            minHeight: "100vh",
            backgroundColor: "white",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center"
        }}>
            <h1 style={{
                fontFamily: "'American Typewriter', 'Courier New', Courier, monospace",
                fontSize: "3.0rem",
                marginBottom: "10px",
                marginLeft: "10px"
            }}>OneWriter<sup style={{ fontSize: "0.4em", verticalAlign: "0.5em" }}>&#8482;</sup></h1>

            <div style={{ lineHeight: "1.3", marginBottom: "16px", fontWeight: "600", fontFamily: "Arial, Helvetica, sans-serif" }}>
                <p style={{ margin: "2px 0", fontStyle: "italic" }}>It's a Word Processor</p>
                <p style={{ margin: "2px 0", fontStyle: "italic" }}>and a Spreadsheet</p>
                <p style={{ margin: "2px 0", fontStyle: "italic", marginLeft: "-5px" }}>
                    <span style={{ fontSize: "1.5em", verticalAlign: "-0.2em" }}>&ldquo;</span>
                    <span style={{ display: "inline-block", width: "3px" }} />
                    IN ONE APP
                    <span style={{ display: "inline-block", width: "1px" }} />
                    <span style={{ fontSize: "1.5em", verticalAlign: "-0.2em" }}>&rdquo;</span>
                </p>
            </div>

            <div style={{
                width: "100%",
                maxWidth: "320px",
                display: "flex",
                flexDirection: "column",
                gap: "12px"
            }}>
                <div>
                    <p>Would you like to learn more?</p>
                </div>

                {/* 1. YouTube */}
                <a
                    href="https://www.youtube.com/@onewriterapp"
                    target="_blank"
                    rel="noopener noreferrer"
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#dcdcdc"; e.currentTarget.style.borderColor = "#aaa"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#e0e0e0"; e.currentTarget.style.borderColor = "#aaa"; }}
                    onMouseDown={(e) => { e.currentTarget.style.backgroundColor = "#c8c8c8"; e.currentTarget.style.transform = "scale(0.98)"; }}
                    onMouseUp={(e) => { e.currentTarget.style.backgroundColor = "#e0e0e0"; e.currentTarget.style.transform = "scale(1)"; }}
                    style={{
                        padding: "10px 20px",
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #aaa",
                        backgroundColor: "#e0e0e0",
                        color: "#222",
                        fontSize: "14px",
                        textDecoration: "none",
                        boxSizing: "border-box",
                        display: "block",
                        transition: "background-color 0.15s ease, transform 0.1s ease"
                    }}
                >
                    Our YouTube channel
                </a>

                {/* 2. Email */}
                <button
                    onClick={handleEmailClick}
                    onMouseEnter={(e) => { if (!emailCopied) { e.currentTarget.style.backgroundColor = "#dcdcdc"; e.currentTarget.style.borderColor = "#aaa"; } }}
                    onMouseLeave={(e) => { if (!emailCopied) { e.currentTarget.style.backgroundColor = "#efefef"; e.currentTarget.style.borderColor = "#bbb"; } }}
                    onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
                    style={{
                        height: "40px",
                        padding: "0 20px",
                        width: "100%",
                        borderRadius: "8px",
                        border: emailCopied ? "1px solid #b2dfb8" : "1px solid #bbb",
                        backgroundColor: emailCopied ? "#d4edda" : "#efefef",
                        color: "#111",
                        fontSize: emailCopied ? "11px" : "14px",
                        cursor: "pointer",
                        boxSizing: "border-box",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        lineHeight: "1.2",
                        transition: "background-color 0.3s ease, border-color 0.3s ease"
                    }}
                >
                    {emailCopied ? (
                        <><strong><u>hello@OneWriter.app</u> copied to clipboard</strong></>
                    ) : (
                        "Email us"
                    )}
                </button>

                {/* 3. Call */}
                <a href={`tel:+1${phone}`}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#c8c8c8"; e.currentTarget.style.borderColor = "#aaa"; e.currentTarget.style.color = "#222"; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#e0e0e0"; e.currentTarget.style.borderColor = "#aaa"; e.currentTarget.style.color = "#222"; }}
                    onMouseDown={(e) => { e.currentTarget.style.backgroundColor = "#c8c8c8"; e.currentTarget.style.transform = "scale(0.98)"; }}
                    onMouseUp={(e) => { e.currentTarget.style.backgroundColor = "#e0e0e0"; e.currentTarget.style.transform = "scale(1)"; }}
                    style={{
                        padding: "10px 20px",
                        width: "100%",
                        borderRadius: "8px",
                        border: "1px solid #aaa",
                        backgroundColor: "#e0e0e0",
                        color: "#222",
                        fontSize: "14px",
                        textDecoration: "none",
                        boxSizing: "border-box",
                        display: "block",
                        transition: "background-color 0.15s ease, transform 0.1s ease"
                    }}
                >
                    Call us
                </a>
            </div>

            <p style={{ marginTop: "40px", fontSize: "12px", color: "#444" }}>
                Created by Jamie Kayam | App About It LLC © {new Date().getFullYear()}
            </p>
        </div>
    );
};

export default PageLearning;